// Types
import {TDealerDetailUpdateState } from '@/types/store/state'
import { DEALER_DETAILS_UPDATE} from '@/types/store/const'

const INITIAL_STATE: TDealerDetailUpdateState = {
  isUpdatingDealerAddress: false, 
}

export const dealerUpdateReducer: any = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case DEALER_DETAILS_UPDATE:
      return {
        ...state,
        isUpdatingDealerAddress: action.payload.isUpdatingDealerAddress, 
      }
    default:
      return state
  }
}
